<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row class="mb-2">
          <b-col md="12" class="d-flex justify-content-end">
            <b-button variant="primary" @click="showAddGpsDeviceModal">
              <feather-icon icon="PlusIcon" class="mr-50" />
              New GPS Device
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="2" sm="1" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
            </b-form-group>
          </b-col>


          <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
            <b-button variant="outline-danger" @click="clearFilters">
              Clear Filters
            </b-button>
          </b-col>


          <b-col cols="12">
            <b-table   v-if="paginatedFilteredDevices.length > 0"
  striped
  hover
  responsive
  :per-page="perPage"
  :current-page="currentPage"
  :items="filteredDevices"

  :fields="gps_fields"
  :sort-by.sync="sortBy"
  :sort-desc.sync="sortDesc"
  :sort-direction="sortDirection"
  :filter="filter"
  :filter-included-fields="filterOn"
  @filtered="onFiltered">

              <template #head(serialNumber)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <b-form-input v-model="filters.serialNumber" placeholder="Search Serial Number" size="sm" />
                </div>
              </template>

              <template #head(installationDate)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <DatePicker v-model="filters.dateRange" range placeholder="Select Date Range" size="sm" />
                </div>
              </template>

              <template #head(status)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <b-form-select v-model="filters.status" :options="statusFilterOptions" size="sm" />
                </div>
              </template>

              <template #cell(actions)="data">
                <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                  </template>
                  <b-dropdown-item @click="showViewGpsDeviceModal(data.item)">
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-1">View</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showEditGpsDeviceModal(data.item)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-1">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="confirmDeleteGpsDevice(data.item.gpsDeviceId)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-1">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
              <template #cell(installationDate)="data">
                {{ beautifyDate(data.item.installationDate) }}
              </template>
            </b-table>
            <div class="d-flex justify-content-center mb-1">
              <div class="d-flex justify-content-center mb-1" v-if="loading">
                <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
              </div>
            </div>
          </b-col>

          <b-col cols="12">
            <b-pagination v-model="currentPage" :total-rows="filteredDevices.length" :per-page="perPage" align="center" size="sm"
              class="my-0" />
              <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
          </b-col>
        </b-row>

        <!-- Modal for adding a new Gps Device-->
        <b-modal ref="modalAddGpsDevice" id="modal-add-gps-device" title="Add New Gps Device" @hide="resetForm"
          hide-footer centered>
          <validation-observer ref="addGpsDeviceForm" v-slot="{ invalid, validate }">
            <b-form @submit.prevent="
              validate().then((success) => success && addNewGpsDevice())
              ">
              <b-form-group label="Serial Number" label-for="serialnumber">
                <validation-provider name="Serial Number" rules="required" v-slot="{ errors }">
                  <b-form-input id="serialnumber" v-model="newGpsDevice.serialNumber" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Installation Date" label-for="installationdate">
                <validation-provider name="Installation Date" rules="required" v-slot="{ errors }">
                  <b-form-datepicker id="installationdate" v-model="newGpsDevice.installationDate" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Status" label-for="status">
                <validation-provider name="Status" rules="required" v-slot="{ errors }">
                  <b-form-select id="status" v-model="newGpsDevice.status" :options="statusOptions" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button type="submit" variant="primary">
                Add GPS Device
              </b-button>
            </b-form>
          </validation-observer>
        </b-modal>

        <!-- Modal for editing a Gps Device -->
        <b-modal ref="modalEditGpsDevice" id="modal-edit-gps-device" title="Edit Gps Device" hide-footer centered>
          <validation-observer ref="editGpsDeviceForm" v-slot="{ invalid, validate }">
            <b-form @submit.prevent="
              validate().then((success) => success && updateGpsDevice())
              ">
              <b-form-group label="Serial Number" label-for="editSerialNumber">
                <validation-provider name="Serial Number" rules="required" v-slot="{ errors }">
                  <b-form-input id="editSerialNumber" v-model="editGpsDevice.serialNumber" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Installation Date" label-for="editInstallationDate">
                <validation-provider name="Installation Date" rules="required" v-slot="{ errors }">
                  <b-form-datepicker id="editInstallationDate" v-model="editGpsDevice.installationDate" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Status" label-for="editStatus">
                <validation-provider name="Status" rules="required" v-slot="{ errors }">
                  <b-form-select id="editStatus" v-model="editGpsDevice.status" :options="statusOptions" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button type="submit" variant="primary" :disabled="invalid">
                Save Changes
              </b-button>
            </b-form>
          </validation-observer>
        </b-modal>

        <!-- Modal for viewing a Gps Device -->
        <b-modal ref="modalViewGpsDevice" id="modal-view-gps" title="View Gps Device" hide-footer centered>
          <b-form>
            <b-form-group label="Serial Number" label-for="viewSerialNumber">
              <b-form-input id="viewSerialNumber" v-model="viewGpsDevice.serialNumber" readonly />
            </b-form-group>
            <b-form-group label="Installation Date" label-for="viewInstallationDate">
              <b-form-input id="viewInstallationDate" :value="beautifyDate(viewGpsDevice.installationDate)" readonly />
            </b-form-group>
            <b-form-group label="Status" label-for="viewStatus">
              <b-form-input id="viewStatus" v-model="viewGpsDevice.status" readonly />
            </b-form-group>
          </b-form>
        </b-modal>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BFormDatepicker,
  BInputGroupAppend,
  BButton,
  BCard,
  BForm,
  BCardBody,
  BDropdown,
  BModal,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});
extend("numeric", {
  ...numeric,
  message: "This field must be a number",
});

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    ValidationObserver,
    ValidationProvider,
    BSpinner,
    BFormDatepicker,
    DatePicker
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 1,
      filter: null,
      sortBy: null,
      sortDesc: null,
      sortDirection: null,
      filterOn: ["serialNumber", "installationDate", "status", "actions"],
      gps_fields: [
        { key: "serialNumber", label: "Serial Number", sortable: true },
        { key: "installationDate", label: "Installation Date", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      filters: {
        serialNumber: "",
        dateRange: [null, null],
        status: null,
      },
      statusFilterOptions: [
        { value: null, text: "All" },
        { value: "Active", text: "Active" },
        { value: "Inactive", text: "Inactive" },
      ],
      newGpsDevice: {
        serialNumber: "",
        installationDate: null,
        status: "",
      },
      viewGpsDevice: {
        serialNumber: "",
        installationDate: null,
        status: "",
      },
      editGpsDevice: {
        gpsDeviceId: null,
        serialNumber: "",
        installationDate: null,
        status: "",
      },
      statusOptions: ["Active", "Inactive"],
      statusVariants: {
        Active: "success",
        Inactive: "danger",
      },
    };
  },
  watch: {
  filteredDevices(newVal) {
    this.totalRows = newVal.length;
    console.log("Total Rows Updated:", this.totalRows);
  }
},

  computed: {
    ...mapGetters("gpsModule", {
      gpsdevices: "gpsdevices",
      loading: "loading",
    }),
    filteredDevices() {
    console.log("Filtering devices...");
    const result = this.gpsdevices.filter((device) => {
      const matchesSerialNumber =
        !this.filters.serialNumber ||
        device.serialNumber.toLowerCase().includes(this.filters.serialNumber.toLowerCase());

      const matchesDate =
        (!this.filters.dateRange[0] && !this.filters.dateRange[1]) ||
        (new Date(device.installationDate) >= new Date(this.filters.dateRange[0]) &&
          new Date(device.installationDate) <= new Date(this.filters.dateRange[1]));

      const matchesStatus = !this.filters.status || device.status === this.filters.status;

      return matchesSerialNumber && matchesDate && matchesStatus;
    });

    console.log("Filtered Devices Count:", result.length);
    return result;
  },
    paginatedFilteredDevices() {
      this.totalRows = this.filteredDevices.length;
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredDevices.slice(start, end);
    },
  },

  methods: {
    ...mapActions("gpsModule", [
      "getGpsDeviceListAction",
      "removeGpsDeviceAction",
      "addGpsDeviceAction",
      "updateGpsDeviceAction",
    ]),
    clearFilters() {
      this.filters = {
        serialNumber: "",
        dateRange: [null, null],
        status: null,
      };
    },
    showAddGpsDeviceModal() {
      this.$refs.modalAddGpsDevice.show();
    },

    resetForm() {
      this.newGpsDevice = {
        serialNumber: null,
        installationDate: null,
        status: null,
      };
      this.editGpsDevice = {
        serialNumber: null,
        installationDate: null,
        status: null,
      };
      this.viewGpsDevice = {
        serialNumber: null,
        installationDate: null,
        status: null,
      };
    },

    beautifyDate(dateString) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      const minDate = new Date("0001-01-01T00:00:00 ");

      const date = new Date(dateString);
      if (date.toLocaleDateString("en-US", options) === 'January 1, 1') {
        return "-";
      }

      return date.toLocaleDateString("en-US", options);
    },

    async addNewGpsDevice() {
  this.loading = true;
  const loader = Swal.fire({
    title: "Processing...",
    text: "Please wait while the GPS Device is being added",
    allowOutsideClick: () => !Swal.isLoading(),
    showConfirmButton: false,
    showCancelButton: false,
    buttonsStyling: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const response = await this.addGpsDeviceAction(this.newGpsDevice);
    
    loader.close();
    this.$bvModal.hide("modal-add-gps-device");
    
    Swal.fire({
      title: "Success",
      text: "GPS Device added successfully.",
      icon: "success",
      customClass: {
        confirmButton: "btn btn-success",
      },
    });

    await this.getGpsDeviceListAction();
    this.totalRows = this.gpsdevices.length;

    this.resetForm();

  } catch (error) {
    loader.close();
    this.error(error.response.data);
  } finally {
    this.loading = false;
  }
},


    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "";
        msg += "";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    showViewGpsDeviceModal(item) {
      this.viewGpsDevice = { ...item };
      this.$refs.modalViewGpsDevice.show();
    },
    showEditGpsDeviceModal(item) {
      this.editGpsDevice = { ...item };
      this.$refs.modalEditGpsDevice.show();
      this.getGpsDeviceListAction();
    },

    async updateGpsDevice() {
      this.loading = true;
      const loader = Swal.fire({
        title: "Processing...",
        text: "Please wait while the Gps Device is being updated",
        allowOutsideClick: () => !Swal.isLoading(),
        showConfirmButton: false,
        showCancelButton: false,
        buttonsStyling: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await this.updateGpsDeviceAction(this.editGpsDevice);
        loader.close();
        this.$bvModal.hide("modal-edit-gps-device");
        this.success("Gps Device updated successfully.");
        this.loading = false;
        this.resetForm();
        this.getGpsDeviceListAction();
      } catch (error) {
        loader.close();
        this.error(error.response.data);
        this.loading = false;
        this.getGpsDeviceListAction();
      } finally {
        this.getGpsDeviceListAction();
        this.loading = false;
      }
    },
    async confirmDeleteGpsDevice(gpsId) {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (confirmation.isConfirmed) {
        this.deleteGpsDevice(gpsId);
      } else if (confirmation.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Your Gps Device is safe :)",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    },

    async deleteGpsDevice(gpsId) {
      const loader = Swal.fire({
        title: "Processing...",
        text: "Please wait while the Gps Device is being deleted",
        allowOutsideClick: () => !Swal.isLoading(),
        showConfirmButton: false,
        showCancelButton: false,
        buttonsStyling: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await this.removeGpsDeviceAction(gpsId);
        loader.close();
        Swal.fire({
          title: "Deleted!",
          text: "The Gps Device has been deleted.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        this.resetForm();
        this.getGpsDeviceListAction();
      } catch (error) {
        loader.close();
        this.error(error.response.data);
        this.getGpsDeviceListAction();
      } finally {
        this.loading = false;
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  async mounted() {
    this.getGpsDeviceListAction().then(() => {
      this.totalRows = this.gpsdevices.length;
    });
  },
};
</script>

<style scoped>
/* Add your existing styles here */
</style>
